var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('router-link',{attrs:{"to":"/about"},nativeOn:{"click":function($event){return _vm.$emit('open')}}},[_vm._v("About")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/contact"},nativeOn:{"click":function($event){return _vm.$emit('open')}}},[_vm._v("Contact")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }